import React from "react";
import HeroForm from "./HeroForm";
import { Check } from "lucide-react";

interface VideoSources {
  webm: string;
  mp4: string;
  ogv: string;
}

interface HeroSectionProps {
  title: string;
  description: string;
  videoSrc?: VideoSources;
  imageSrc?: string;
  imageAlt?: string;
  trustpilot?: boolean;
}

function HeroSection({
  title,
  description,
  videoSrc,
  imageSrc,
  imageAlt,
  trustpilot = false,
}: HeroSectionProps) {
  return (
    <div className="relative grid grid-cols-1 w-full md:grid-cols-[1fr_auto] pt-24 md:pt-[55px] bg-gray-50">
      <div className="absolute w-full h-[510px] overflow-hidden bg-[#2FB6D2]">
        <div className="relative w-full h-[510px]">
          <div className="absolute -bottom-[1px] z-[3] left-1/2 -translate-x-1/2">
            <svg
              width="3840"
              height="327"
              viewBox="0 0 3840 327"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 0.136719V326.999H3840V0.136719C3840 0.136719 3128.32 302.999 1920 302.999C711.68 302.999 0 0.136719 0 0.136719Z"
                fill="#f9fafb"
              />
            </svg>
          </div>
        </div>
      </div>

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] grid mb-16 md:mb-24 grid-rows-[auto_1.8fr] md:grid-rows-none md:grid-cols-[1fr_1.8fr]">
        <div className="grid place-content-center row-[2] z-[4] md:place-content-start md:w-[448px] md:col-[1] md:row-[1]">
          <div className="overflow-visible">
            <div>
              <HeroForm title={title} description={description} />
            </div>
          </div>
        </div>

        {(videoSrc || imageSrc) && (
          <div className="relative  md:mr-[10px] min-h-[250px] flex place-items-start justify-center">
            {videoSrc ? (
              <video className="w-full object-cover" loop autoPlay playsInline>
                <source src={videoSrc.webm} type="video/webm" />
                <source src={videoSrc.mp4} type="video/mp4" />
                <source src={videoSrc.ogv} type="video/ogg" />
              </video>
            ) : imageSrc ? (
              <div className="relative">
                <img
                  src={imageSrc}
                  alt={imageAlt || ""}
                  className="max-w-[350px] md:max-w-full md:w-fit mx-auto relative z-10 md:h-full object-cover"
                />

                <span className="z-10 hidden xl:block absolute lg:text-md bg-white px-3 py-1.5 rounded-md -top-9 mx-auto lg:top-6 lg:-right-28 font-bold">
                  <div className="flex items-center gap-1">
                    <Check className="w-6 h-6 text-[#F47B20]" /> Kwaiteit in
                    stroom, eerlijk in prijs!
                  </div>
                </span>
              </div>
            ) : null}
          </div>
        )}
      </section>
    </div>
  );
}

export default HeroSection;
